<template>
<svg id="Capa_1" data-name="Capa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
  <path :fill="color" d="M58.59,38l.53,2.76c1.81,9.45,9.19,16.83,18.64,18.64l2.76.53c1.5.29,1.5,2.44,0,2.73l-2.76.53c-9.45,1.81-16.83,9.19-18.64,18.64l-.53,2.76c-.29,1.5-2.44,1.5-2.73,0l-.53-2.76c-1.81-9.45-9.19-16.83-18.64-18.64l-2.76-.53c-1.5-.29-1.5-2.44,0-2.73l2.76-.53c9.45-1.81,16.83-9.19,18.64-18.64l.53-2.76c.29-1.5,2.44-1.5,2.73,0Z"/>
  <path :fill="color" d="M30.6,33.05l.25,1.31c.86,4.49,4.37,8,8.86,8.86l1.31.25c.71.14.71,1.16,0,1.29l-1.31.25c-4.49.86-8,4.37-8.86,8.86l-.25,1.31c-.14.71-1.16.71-1.29,0l-.25-1.31c-.86-4.49-4.37-8-8.86-8.86l-1.31-.25c-.71-.14-.71-1.16,0-1.29l1.31-.25c4.49-.86,8-4.37,8.86-8.86l.25-1.31c.14-.71,1.16-.71,1.29,0Z"/>
  <path :fill="color" d="M51.1,14.71l.2,1.04c.68,3.56,3.46,6.34,7.02,7.02l1.04.2c.57.11.57.92,0,1.03l-1.04.2c-3.56.68-6.34,3.46-7.02,7.02l-.2,1.04c-.11.57-.92.57-1.03,0l-.2-1.04c-.68-3.56-3.46-6.34-7.02-7.02l-1.04-.2c-.57-.11-.57-.92,0-1.03l1.04-.2c3.56-.68,6.34-3.46,7.02-7.02l.2-1.04c.11-.57.92-.57,1.03,0Z"/>
</svg>
</template>

<script>
export default {
  name: 'MagicIcon',
  props: {
    color: {
      type: String,
      default: '#000000'
    }
  }

}
</script>

<style>

</style>
